import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getQuoteDocumentSettings, saveQuoteDocumentSettings, type QuoteDocumentWrite } from '@/services/quoteDocument'

export const quoteDocumentKey = ['admin', 'quote-document'] as const

export function useQuoteDocumentSettings() {
  return useQuery({ queryKey: quoteDocumentKey, queryFn: getQuoteDocumentSettings, retry: false })
}

export function useSaveQuoteDocumentSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (write: QuoteDocumentWrite) => saveQuoteDocumentSettings(write),
    onSuccess: (data) => qc.setQueryData(quoteDocumentKey, data),
  })
}
